import { Component, Inject, Input } from "@angular/core";

import { Observable, Subject, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

import { MatTableDataSource } from "@angular/material/table";

import { CommandRelay } from '../../../../shared/commands/command-relay.class';

import { ConsignesSecuriteGeneralesEntity } from "../../entities/consignes-securite-generales.entity";
import { ConsignesSecuriteGeneralesService } from "../../services/consignes-securite-generales.service";

enum TypeConsignesSecurite {
	ACCES_OUVRAGES_LIMITATION,
	CONDITION_METEO,
	OBLIGATION,
	INTERDICTION,
	TRAVAILLEUR_ISOLE,
	SOUS_TRAITANCE,
	MISE_A_JOUR_PDP,
	SPECIALITE_SITE,
	ORGANISATION_SECOURS
}

@Component({
	selector: 'consignes-securite-generales',
	templateUrl: 'consignes-securite-generales.html',
	styleUrls: ['consignes-securite-generales.css']
})
export class ConsignesSecuriteGeneralesComponent {
	
	/* Consignes de sécurités générales */
	accesOuvragesLimitations: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	conditionsMeteorologiques: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	obligations: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	interdictions: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	travailleursIsoles: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	sousTraitance: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	miseAjourPdp: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	specificiteSite: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	organisationSecours: MatTableDataSource<ConsignesSecuriteGeneralesEntity> = new MatTableDataSource<ConsignesSecuriteGeneralesEntity>();
	displayedColumnsConsignesSecuriteGenerales: string[] = ['consignes'];
	
	private energieSubject = new Subject<string | null>();
	private reinitSubject = new Subject<void>(); 

	constructor(
		@Inject(ConsignesSecuriteGeneralesService) private consignesSecuriteGeneralesService: ConsignesSecuriteGeneralesService
	) {
		// Charger les consignes de securite
		let consignesSecuriteGenerales$ = this.consignesSecuriteGeneralesService.getAllConsignesSecuriteGenerales();
		
		// Des que les consignes sont disponibles, les classer par energie
		let consignesPossiblesByEnergie$ = consignesSecuriteGenerales$.pipe(
			map(
				(consignes) => {
					let map = new Map<string, ConsignesSecuriteGeneralesEntity[]>();
					
					let eolienneInfos = consignes.filter(cons => cons.category === 0 || cons.category === 2);
					map.set("Eolienne", eolienneInfos);
					
					let solaireInfos = consignes.filter(cons => cons.category === 1 || cons.category === 2);
					map.set("Solaire", solaireInfos);
					
					return map;
				}
			)
		);
		
		// Definir les consignes a afficher en fonction de l'energie actuellement selectionnne via le parc dans le pdp
		let energieConsignes$ = combineLatest([consignesPossiblesByEnergie$, this.energieSubject]).pipe(
			map(
				(data) => {
					let cconsignesPossiblesByEnergie = data[0];
					let energie = data[1];
					if (!energie) {
						return [];
					}
					
					let energieConsignes = cconsignesPossiblesByEnergie.get(energie);
					if (!energieConsignes) {
						throw new Error("Type d'energie non reconnu: " + energie);
					}
					
					return energieConsignes;
				}
			)
		);
		
		// Finalement quand les consignes a afficher sont connues et que l'initialisation de la vue a eu lieu'
		// Proceder a la mise a jour des proprietes a bind sur la vue
		combineLatest([energieConsignes$, this.reinitSubject]).subscribe(
			(data) => {
				let consignes = data[0];
				this.accesOuvragesLimitations.data = consignes.filter(value => value.type === TypeConsignesSecurite.ACCES_OUVRAGES_LIMITATION);
				this.conditionsMeteorologiques.data = consignes.filter(value => value.type === TypeConsignesSecurite.CONDITION_METEO);
				this.obligations.data = consignes.filter(value => value.type === TypeConsignesSecurite.OBLIGATION);
				this.interdictions.data = consignes.filter(value => value.type === TypeConsignesSecurite.INTERDICTION);
				this.travailleursIsoles.data = consignes.filter(value => value.type === TypeConsignesSecurite.TRAVAILLEUR_ISOLE);
				this.sousTraitance.data = consignes.filter(value => value.type === TypeConsignesSecurite.SOUS_TRAITANCE);
				this.miseAjourPdp.data = consignes.filter(value => value.type === TypeConsignesSecurite.MISE_A_JOUR_PDP);
				this.specificiteSite.data = consignes.filter(value => value.type === TypeConsignesSecurite.SPECIALITE_SITE);
				this.organisationSecours.data = consignes.filter(value => value.type === TypeConsignesSecurite.ORGANISATION_SECOURS);
			}
		);
	}

	private energieChangeCommandRelay = new CommandRelay<string | null>((energie) => this.energieSubject.next(energie));
	@Input() set energieChangeCommand(obs: Observable<string | null>) {
		this.energieChangeCommandRelay.register(obs);
	}

	ngAfterViewInit() {
		// Proceder a l'initialisation de l'affichage
		this.reinitSubject.next();
	}
}